// extracted by mini-css-extract-plugin
module.exports = {"Bold":"Home_Bold__11m_g","Hero":"Home_Hero__3mxCx","HeroTextBox":"Home_HeroTextBox__2TqWU","HeroText":"Home_HeroText__2J6rz"};